var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-hidden": "true",
    role: "img",
    className: "iconify iconify--medical-icon",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.1 54.673a7.628 7.628 0 0 0 1.276-7.45l-.877-2.407h5.277V.315H3.523v44.501h30.789l3.356 9.222a7.62 7.62 0 0 0 5.764 4.883l1.477 4.915h13.564L55.1 54.674zm-1.686-15.52l-1.252-3.411l-1.859-5.117c-2.83 1.033-4.29 4.156-3.255 6.98l2.037 5.559H5.175V1.969h53.951v41.195h-4.237l-1.473-4.011z",
    fill: "#000000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.842 11.147c1.434-1.467 3.258-2.199 5.469-2.199c2.965 0 5.131.982 6.5 2.947c.757 1.103 1.162 2.21 1.217 3.322H28.31c-.237-.853-.542-1.498-.912-1.934c-.662-.771-1.644-1.158-2.944-1.158c-1.324 0-2.37.546-3.135 1.636c-.765 1.092-1.146 2.635-1.146 4.63c0 1.997.403 3.492 1.21 4.486c.806.995 1.832 1.491 3.076 1.491c1.276 0 2.249-.425 2.918-1.278c.37-.46.678-1.149.921-2.066h3.696c-.32 1.94-1.133 3.517-2.442 4.734c-1.311 1.215-2.99 1.822-5.036 1.822c-2.532 0-4.523-.82-5.972-2.462c-1.452-1.651-2.175-3.913-2.175-6.785c0-3.108.824-5.502 2.473-7.184z",
    fill: "#000000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.931 9.286v3.152h-5.325v14.648h-3.745V12.438h-5.347V9.286h14.417z",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCt);
export default __webpack_public_path__ + "static/media/ct.64f27e9b5d98421a20f04c517706c48c.svg";
export { ForwardRef as ReactComponent };